<template>
  <div class="deadline-alert" @click="moveToSaleList()">
    <v-img class="deadline-alert-icon" src="../../../assets/icon_info.svg" />
    <div class="deadline-alert-label">
      {{ $t('common.common_new-order-alert') }}
    </div>
    <v-btn
      class="deadline-alert-close"
      width="10px"
      height="10px"
      icon
      @click.stop.prevent="onClickdAlertRead"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  methods: {
    onClickdAlertRead() {
      this.$emit('onClickdAlertRead')
    },
    moveToSaleList() {
      this.$router.push({
        name: 'sales.history'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.deadline-alert {
  position: relative;
  background-color: #d8f2d6;
  border: 1px solid;
  border-radius: 6px;
  border-color: #a0c889;
  padding: 12px;
  display: flex;
  justify-content: left;
  align-items: center;
  height: 46px;
  margin-bottom: 4px;
  cursor: pointer;

  &-icon {
    max-width: 20px !important;
    height: 20px;
  }
  &-label {
    font-size: 14px;
    height: 20px;
    margin-left: 12px;
  }

  &-close {
    position: absolute;
    color: #91c971 !important;
    right: 20px;
  }
}
</style>
